/** Ekimetrics palette, taken from the Ekimetrics Keycloak theme (--eki-background*) and the logo accent. */
export const brand = {
  japaneseBlue: '#1a2744',
  japaneseBlueLight: '#243352',
  japaneseBlueDark: '#111c2e',
  accent: '#7df3e1',
  success: '#2fa38a',
  danger: '#d6455d',
  warning: '#e0a030',
};

/** Dark theme: navy surfaces derived from the Japanese blue, lighter blue for readable foreground colors. */
export const darkPalette = {
  pageBackground: '#0b1220',
  surface: '#141f36',
  border: '#2a3a5c',
  primary: '#8fb0f0',
  primaryDark: '#5f86cf',
};

/** Foreground color of numbers, charts and icons: the brand blue on light surfaces, a lighter blue on dark ones. */
export const foreground = (type: 'light' | 'dark') =>
  type === 'dark' ? darkPalette.primary : brand.japaneseBlue;

/** Gradients of the ownership tiles: shades of the brand blue, with the logo accent as a teal. */
export const tileGradients = [
  ['#1a2744', '#34528f'],
  ['#243352', '#4468b0'],
  ['#111c2e', '#2c4268'],
  ['#1d5560', '#2f9aa0'],
  ['#2b3a67', '#5871c4'],
] as const;
